import React, { Component, Fragment } from "react";
import {
  Row, Card, CardTitle, Form, Label, Input, Button, Modal, ModalBody,
  ModalFooter, ModalHeader, Tooltip
} from "reactstrap";
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import IntlMessages from "../../../../helpers/IntlMessages";
import { AxiosUserAPI, getUserID } from '../../../../helpers/AxiosAPI';
import { postAPI_UpdatePassword, postAPI_VerifyForgotPassword } from '../../../../constants/APIs';
import { NotificationManager } from "../../../../components/common/react-notifications";
import PasswordStrengthBar from 'react-password-strength-bar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: 'ForgotFlow',
      oldPassword: '',
      password: '',
      confirmPassword: '',
      message: '',
      creator: 'user',
      isShow: false,
      tooltip: false,
      isPasswordVisible: false,
      isNewPasswordVisible: false,
      isConfirmPasswordVisible: false,
    };
  }


  handleChangePassword = password => {
    this.setState({
      password: password.target.value,
    });
  };

  handleChangeoldPassword = password => {
    this.setState({
      oldPassword: password.target.value,
    });
  };

  handleChangeConfirmPassword = password => {
    this.setState({
      confirmPassword: password.target.value,
    });
  };
  onUserResetPassword() {
    let data = {
      reason: 'UserInitiatedReset',
      oldPassword: this.state.oldPassword,
      password: this.state.password,
      creator: 'user',
      auditBy: this.props.userName
    }

    var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;
    if (this.state.password.length >= 12 && this.state.password.length <= 16 &&
      /(?=.*[A-Z])/.test(this.state.password) && /(?=.*[a-z])/.test(this.state.password) &&
      /(?=.*[0-9])/.test(this.state.password) && /(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(this.state.password)) {

      if (this.state.password !== this.state.confirmPassword) {
        this.setState({ message: 'Password and confirm password are not matched.' });
        this.setState({ isShow: true });
      } else {
        this.setState({ process: true, loading: true });

        AxiosUserAPI({
          method: 'put',
          url: `${postAPI_UpdatePassword}/${getUserID()}/change-password`,
          data: data
        }).then(
          res => {
            if (res.data.userId !== undefined) {
              NotificationManager.success(
                "Password Changed Successfully",
                "Password Changed Success",
                3000,
                null,
                null,
                "success"
              );
            } else {
              NotificationManager.error(
                "Current Password Is Invalid",
                "Current Password Is Invalid",
                3000,
                null,
                null,
                "error"
              );
            }
          },
          error => {
            console.log('eee.data', error.data);
          }
        );
      }
    }
    else {
      this.setState({ message: 'Password length must be in between of 12 to 16 character and its must have atleast 1 upper case, 1 lower case, 1 digit and 1 special character.' });
      this.setState({ isShow: true });
    }
  }
  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      isPasswordVisible: !prevState.isPasswordVisible,
    }));
  };
  toggleNewPasswordVisibility = () => {
    this.setState((prevState) => ({
      isNewPasswordVisible: !prevState.isNewPasswordVisible,
    }));
  };
  toggleConfirmPasswordVisibility = () => {
    this.setState((prevState) => ({
      isConfirmPasswordVisible: !prevState.isConfirmPasswordVisible,
    }));
  };
  render() {
    return (
      <Fragment>
        <Row className="h-100">
          <Colxx xxs="12" md="10" className="mx-auto my-auto">
            <Card className="auth-card">
              <div className="position-relative image-side ">
                <p className="text-white h2">AI OMNI-CHANNEL COMMUNICATIONS PLATFORM</p>
                <p className="white mb-0">
                  Please enter the new password.
                </p>
              </div>
              <div className="form-side">
                <CardTitle className="mb-4">
                  Change Password
                </CardTitle>
                <div className='m-2'>
                  <h6>Your password must contain </h6>
                  <ul className='ml-3'>
                    <li className='mb-2'>Atleast 12 Characters.</li>
                    <li className='mb-2'>Atleast one upper case letter.</li>
                    <li className='mb-2'>Atleast one lower case letter.</li>
                    <li className='mb-2'>Atleast one number.</li>
                    <li className='mb-2'>Atleast one of the following symbols (?=.*[@#$%^&-+=()]).</li>
                  </ul>
                </div>
                <Form>
                  <Label className="form-group has-float-label mb-4">
                    <Input className='input_sty' type={this.state.isPasswordVisible ? 'text' : 'password'} onChange={this.handleChangeoldPassword} />
                    <IntlMessages id="user.currentpassword" />
                    <FontAwesomeIcon
                      icon={this.state.isPasswordVisible ? faEyeSlash : faEye}
                      onClick={this.togglePasswordVisibility}
                      style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '10px' }}
                    />
                  </Label>
                  <Label className="form-group has-float-label mb-2" id="Tooltip">
                    <Input className='input_sty' type={this.state.isNewPasswordVisible ? 'text' : 'password'} onChange={this.handleChangePassword} />
                    <IntlMessages id="user.newpassword" />
                    <FontAwesomeIcon
                      icon={this.state.isNewPasswordVisible ? faEyeSlash : faEye}
                      onClick={this.toggleNewPasswordVisibility}
                      style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '10px' }}
                    />
                  </Label>
                  <Tooltip
                    placement={'right'}
                    isOpen={this.state.tooltip}
                    target={"Tooltip"}
                    toggle={() => this.setState(prevState => ({
                      tooltip: !prevState.tooltip
                    }))}
                  >
                    <p className='text-start' style={{ color: `${(this.state.password.length >= 12) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast 12 characters</span></p>
                    <p className='text-start' style={{ color: `${/(?=.*[A-Z])/.test(this.state.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one upper case character</span></p>
                    <p className='text-start' style={{ color: `${/(?=.*[a-z])/.test(this.state.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one lower case character</span></p>
                    <p className='text-start' style={{ color: `${/(?=.*[0-9])/.test(this.state.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one number</span></p>
                    <p className='text-start' style={{ color: `${/(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(this.state.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one special character</span></p>
                  </Tooltip>
                  {this.state.password !== '' && <div className=""><PasswordStrengthBar
                    password={this.state.password}></PasswordStrengthBar>
                  </div>}
                  <Label className="form-group has-float-label my-4">
                    <Input className='input_sty' type={this.state.isConfirmPasswordVisible ? 'text' : 'password'} onChange={this.handleChangeConfirmPassword} />
                    <IntlMessages id="user.newpasswordagain" />
                    <FontAwesomeIcon
                      icon={this.state.isConfirmPasswordVisible ? faEyeSlash : faEye}
                      onClick={this.toggleConfirmPasswordVisibility}
                      style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '10px' }}
                    />
                  </Label>
                  <div className="d-flex justify-content-end align-items-center">
                    <Button
                      color="primary"
                      className="btn-shadow"
                      size="lg"
                      onClick={() => this.onUserResetPassword()}
                    >
                      <IntlMessages id="user.reset-password-button" />
                    </Button>
                  </div>
                </Form>
              </div>
            </Card>
          </Colxx>
        </Row>
        <Modal isOpen={this.state.isShow} toggle={() => this.setState({ isShow: !this.state.isShow })}>
          <ModalHeader toggle={() => this.setState({ isShow: !this.state.isShow })}>
            Password
          </ModalHeader>
          <ModalBody>
            <h6 className="m-2">{this.state.message}</h6>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => this.setState({ isShow: !this.state.isShow })}>Close</Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}
const mapStateToProps = ({ settings }) => {
  const { userName } = settings;
  return {
    userName
  };
};

export default injectIntl(connect(mapStateToProps, {})(ChangePassword));
